import { Component } from '@angular/core';
import { MatRipple, MatRippleModule } from '@angular/material/core';

@Component({
  selector: 'button[shMenuItem]',
  templateUrl: 'menu-item.component.html',
  standalone: true,
  imports: [MatRippleModule],
  host: {},
  hostDirectives: [MatRipple]
})
export class ShMenuItemComponent {}
